import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import Spinner from 'components/Spinner/Spinner';
import { ROUTES, ROUTES_PATHS } from 'routes/constants';

const Content = () =>
  <Suspense fallback={<Spinner isMain />}>
    <Routes>
      {ROUTES.map((route) => <Route key={route.path} {...route} />)}
      <Route path="*" element={<Navigate to={ROUTES_PATHS.home} replace />} />
    </Routes>
  </Suspense>;

export default Content;
